module.exports = __webpack_public_path__ + "img/摄像头.47d1a3d8.png";